async function DeleteAction(mutationName, id) {
  try {
    await mutationName(id);
  } catch (error) {
    console.log({ addError: error });
  }
}

export default DeleteAction;
